import React, { useContext,useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { methods } from '../../Validation';
import { GlobalContext } from '../../GlobalContext';
import axios from 'axios';
//import { faL } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
    const { t, i18n } = useTranslation();
    const [showThanks,setSetshowThanks] = useState(true);
      const [globalerror,setGlobalerror] = useState(null);
      const loader = document.getElementById("loder-tive");
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber:'',
        address:'',
        address:'',
        mailingAddress:'',
        receivePhysicalMail:false,
        emailSubscription:true

      });

      const [formdata_valid_error,setFormDatavalid] = useState({//validName
        firstName: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"First Name name is required"},
    {keyname:'name',methods:'validName',parmeters:[],errormag:"Please use letters only"}],error:false,errormsg:null
        },
        lastName: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"last Name name is required"},
    {keyname:'name',methods:'validName',parmeters:[],errormag:"Please use letters only"}],error:false,errormsg:null
        },
        email: {validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Email is required"},
        {keyname:'email',methods:'emailMethods',parmeters:[],errormag:"Please enter a valid email address"}],error:false,errormsg:null},
        phoneNumber:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Phone number is required"}
    ],error:false,errormsg:null},
        address:{validtion:[{keyname:'required',methods:'requiredMethods',parmeters:[],errormag:"Address is required"}],error:false,errormsg:null},

      });

      const hanlecheck = (e) =>{
         const { name, value } = e.target;
         if (e.target.checked) {
           
               setFormData(prev => ({
          ...prev,
          [name]: true
        }));
            } else {
                   setFormData(prev => ({
          ...prev,
          [name]: false
        }));
              
            }
      };

      const handleChange = (e) => {
        const { name, value } = e.target;
       
        if (name in formdata_valid_error) {
            if('validtion' in formdata_valid_error[name]){
           
              let result = null;
              let newformdata;
                for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                    if (methods[formdata_valid_error[name].validtion[i].methods]) {
                        result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                        }
                   if(result == false){
                    formdata_valid_error[name].error = true;
                    formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                    newformdata = formdata_valid_error[name];
                     setFormDatavalid(prev => ({
                    ...prev,
                    [name]:newformdata
                    }));
                    break;
                   }
                   if(result == true){
                    
                      formdata_valid_error[name].error = false;
                    formdata_valid_error[name].errormsg = null;
                    newformdata = formdata_valid_error[name];
                     setFormDatavalid(prev => ({
                    ...prev,
                    [name]:newformdata
                    }));
                   }

            }
            
            }
 
        }
      
        setFormData(prev => ({
          ...prev,
          [name]: value
        }));
      };

      const handleSubmit = (e) => {
        e.preventDefault(); 
        loader.classList.remove('d-none');
        console.log('studenet submit');
        let value;
        for (const name in formData) {
            value = formData[name];
            if (name in formdata_valid_error) {
            if('validtion' in formdata_valid_error[name]){
           
              let result = null;
              let newformdata;
                for (let i = 0; i < formdata_valid_error[name].validtion.length; i++) {
                    if (methods[formdata_valid_error[name].validtion[i].methods]) {
                        result = methods[formdata_valid_error[name].validtion[i].methods](value,formdata_valid_error[name].validtion[i].parmeters); 
                        }
                   if(result == false){
                    formdata_valid_error[name].error = true;
                    formdata_valid_error[name].errormsg = formdata_valid_error[name].validtion[i].errormag;
                    newformdata = formdata_valid_error[name];
                     setFormDatavalid(prev => ({
                    ...prev,
                    [name]:newformdata
                    }));
                    break;
                   }
                   if(result == true){
                    
                      formdata_valid_error[name].error = false;
                    formdata_valid_error[name].errormsg = null;
                    newformdata = formdata_valid_error[name];
                     setFormDatavalid(prev => ({
                    ...prev,
                    [name]:newformdata
                    }));
                   }

            }
            
            }
 
        }
            }
                const isChecked = document.getElementById('tramscondtions').checked;
                document.getElementById('tramscondtions').parentNode.classList.remove('error');
             
            let validation = true;
             for (const key in formdata_valid_error) {
                if(formdata_valid_error[key].error == true){
                    loader.classList.add('d-none');
                   validation = false; 
                   break;
                }
             }
             //tramscondtions
           if(!isChecked){
                  document.getElementById('tramscondtions').parentNode.classList.add('error');
                  loader.classList.add('d-none');

                validation = false; 
                console.log('trms condions not selected');
                  
              }

             if(validation){
               let registration_id =  sessionStorage.getItem('session_id');
               console.log(registration_id)
                setFormData(prev => ({
          ...prev,
          trainingSessionId: registration_id
        }));
           
                console.log('Form submitted:', 'success');
                console.log('Form submitted:', formData);
                handleSubmit_axios(formData);
                
             }else{
                loader.classList.add('d-none'); 
                console.log('Form submitted:', 'faild');
                console.log('Form submitted:', formData);
             } 
      };

       const { siteName } = useContext(GlobalContext);
            let baseUrl = siteName.baseUrl;
            let defult_endpoint = siteName.training_endpoits;

            const handleSubmit_axios = async (formData) => {
       
        try {
        //  const response = await axios.post(baseUrl+defult_endpoint+'register/student', formData);

          let formdata_submit = formData
          formdata_submit.emailSubscription = true;
          formdata_submit.trainingSessionId = sessionStorage.getItem('session_id');
               const response = await axios.post(baseUrl+defult_endpoint+'register/student', formdata_submit);
          let data = response;
          

          /*call back data*/
        setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber:'',
        address:'',
        mailingAddress:'',
        emailSubscription:true

      });
      if(data.status){
         loader.classList.add('d-none');
        setSetshowThanks(false);
        
      }
      //window.location.reload();
         
        } catch (error) {
            loader.classList.add('d-none');
          //setErrormsg(error.response.data.message);
          console.log(error.response.data);
          setGlobalerror(error.response.data.message);
          /*error call back*/
        }
      };
     const reset_input_value = () => {
      console.log(formData)
          setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber:'',
        address:'',
        mailingAddress:'',
        emailSubscription:true

      });
    
      
     } 

  return (  
                <div className="modal video-show-modal trainer-show-modal login-modal fade" id="studentModal"  aria-labelledby="studentModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                <Link to="#"><img src="img/CfaN.png" alt=""/></Link>
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={reset_input_value} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                        
                           {showThanks ?  <form onSubmit={handleSubmit} >
                            <span className="registration-title text-center">{t("Registration_as_a_trainee")}</span>
                            {globalerror != null? <div className='error_global error'>{globalerror}</div> : ''}
                                <div className="inner-form-wrap">
                                <div className="form-column">
                                    <label htmlFor="username">{t("First_name")} </label>
                                    <input type="text" onChange={handleChange} name="firstName" value={formData.firstName}  placeholder={t("First_name")} />
                                    {formdata_valid_error.firstName.error? <div className="error">{formdata_valid_error.firstName.errormsg}</div> : ''}
                                </div>
                                <div className="form-column">
                                    <label htmlFor="username">{t("Last_name")} </label>
                                    <input type="text" onChange={handleChange} name="lastName" value={formData.lastName}  placeholder={t("Last_name")} />
                                    {formdata_valid_error.lastName.error? <div className="error">{formdata_valid_error.lastName.errormsg}</div> : ''}
                                </div>
                                <div className="form-column">
                                    <label htmlFor="username">{t("Email_Address")}</label>
                                    <input type="text" onChange={handleChange} name="email" value={formData.email}  placeholder={t("Email_Address")}  />
                                    {formdata_valid_error.email.error? <div className="error">{formdata_valid_error.email.errormsg}</div> : ''}
                                </div>
                                <div className="form-column">
                                    <label htmlFor="username"> {t("Phone_number")} </label>
                                    <input type="text" onChange={handleChange} name="phoneNumber" value={formData.phoneNumber}  placeholder={t("Phone_number")} />  
                                    {formdata_valid_error.phoneNumber.error? <div className="error">{formdata_valid_error.phoneNumber.errormsg}</div> : ''}  
                                </div>
                                <div className="form-column">
                                    <label htmlFor="username">{t("Address")}</label>
                                    <textarea onChange={handleChange} value={formData.address} name="address"></textarea>
                                    {formdata_valid_error.address.error? <div className="error">{formdata_valid_error.address.errormsg}</div> : ''}  
                                </div>

                              
                                
                                 <div className="form-column">
                                      <div className="mailing-label"><input type="checkbox" id="receivePhysicalMail" name="receivePhysicalMail" onChange={hanlecheck} />
                                    <label htmlFor="receivePhysicalMail">{t("I_have_a_mailing_address")}</label></div>
                                    {formData.receivePhysicalMail? 
                              
                                    <textarea onChange={handleChange} value={formData.mailingAddress} name="mailingAddress"  { ...formData.receivePhysicalMail? "disabled" : ''}></textarea>
                                      : ''}
                                </div>
                              
                           
                                </div>
                              
                                <div className="form-agree-statement form-terms">
                                    <input type="checkbox" id="tramscondtions" name="" />
                                    <label htmlFor="terms">{t("I_accept_the")} <a href="https://cfan.org/policies/terms">{t("Terms_Conditions")}</a>.</label>
                                </div>
                                <div className="form-agree-statement">
                                    <input type="checkbox" onChange={handleChange} name="emailSubscription" value="1" />
                                    <label htmlFor="organization">{t("YES_I_would_like_to_receive_communications_from_this_organization")}</label>
                                </div>
                                <input type="submit" value={t("registration")}/>                              
                            </form> :
                            <div className="registration-title text-center">
                            Trainee Registration Successful! Check your email
                            </div>}
                        </div>
                        </div>
                    </div>
                    </div>
  );
};

export default Login;